import { render, staticRenderFns } from "./Tab-Orders.vue?vue&type=template&id=482903b5"
import script from "./Tab-Orders.vue?vue&type=script&lang=js"
export * from "./Tab-Orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports